$(document).foundation();
var $html = $("body");
if ($html.hasClass('template-index') || $html.hasClass('template-collection') || $html.hasClass('We Believe') || $html.hasClass('Free Trial') || $html.hasClass('Box') || $html.hasClass('Triathlon') || $html.hasClass('Ironman') || $html.hasClass('Hiking') || $html.hasClass('Swim') || $html.hasClass('Running') || $html.hasClass('Cycling') || $html.hasClass('landing') || $html.hasClass('trial-flow-landing') || $html.hasClass('landing-dark') || $html.hasClass('trial-flow-landing-dark') || $html.hasClass('landing-trial') || $html.hasClass('trial-flow-landing-trial') || $html.hasClass('que-ironman') || $html.hasClass('template-product')) {
// Add Sticky Class to Header and Logo for changing its color
  var header = jQuery(".fixed");
  var header_block = jQuery (".top-bar");
  var fixedScroll = "fixing-scroll";
  var headerScroll = "header-scrolled";
  header.find('img.dark_logo').hide();

  // jQuery(document).scroll( function() {
  //   if(jQuery(this).scrollTop() > 0) {
  //       header.addClass(fixedScroll);
  //       header_block.addClass(headerScroll);
  //       header_block.find('img.dark_logo').show();
  //       header_block.find('img.light_logo').hide();
  //   } else {
  //       header.removeClass(fixedScroll);
  //       header_block.removeClass(headerScroll);
  //       header_block.find('img.dark_logo').hide();
  //       header_block.find('img.light_logo').show();
  //   }
  // });
}
else {
  // jQuery(".fixed").find('img.light_logo').hide();
  //   jQuery (".top-bar").addClass("header-scrolled");
}

// Wrapping h3 and p from ingredient section on product details page.
jQuery(document).ready( function() {
  jQuery(".benefits_wrapper h3").each(function(index) {
  jQuery(this).next("ul").andSelf().wrapAll("<div class='element-wrapper' />");
  });
  jQuery('.benefits_wrapper h3:contains("Natural energy")').parent().addClass('first_icon');
  jQuery('.benefits_wrapper h3:contains("Healthy fats")').parent().addClass('second_icon');
  jQuery('.benefits_wrapper h3:contains("Plant-based protein")').parent().addClass('third_icon');
  jQuery('.benefits_wrapper h3:contains("Energizing carbs")').parent().addClass('fourth_icon');

// For home slider
  jQuery('.home_slider').flexslider({
    animation: "slide",
    directionNav:false,
    slideshow: true,
    slideshowSpeed: 3000
  });

// Related product slider

  jQuery("#content-slider").lightSlider({
        item:2,
        controls: true,
        loop:true
  });


var totalSlides = jQuery('#content-slider li').length;
  if (totalSlides > 3 ){
    jQuery('.lSAction').hide();
  }

// Cart increement-decrement
  jQuery('.btn-number').click(function(e){
      e.preventDefault();
      fieldName = jQuery(this).attr('data-field');
      type      = jQuery(this).attr('data-type');
      var input = jQuery("input[id='"+fieldName+"']");
      var currentVal = parseInt(input.val());
      if (!isNaN(currentVal)) {
          if(type == 'minus') {
              if(currentVal > input.attr('min')) {
                  input.val(currentVal - 1).change();
              }
              if(parseInt(input.val()) == input.attr('min')) {
                  jQuery(this).attr('disabled', false);
              }
          } else if(type == 'plus') {
              if(currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
              }
              if(parseInt(input.val()) == input.attr('max')) {
                  jQuery(this).attr('disabled', false);
              }
          }
      } else {
          input.val(0);
      }
  });

// Setting boundary limit for quantity
  jQuery('.input-number').change(function() {
      minValue =  parseInt(jQuery(this).attr('min'));
      maxValue =  parseInt(jQuery(this).attr('max'));
      valueCurrent = parseInt(jQuery(this).val());
      //console.log(valueCurrent);
      name = jQuery(this).attr('id');
      if(valueCurrent >= minValue) {
          $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('')
      } else {
          jQuery(this).val(jQuery(this).data('oldValue'));
      }
      if(valueCurrent <= maxValue) {
          jQuery(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('')
      } else {
          jQuery(this).val(jQuery(this).data('oldValue'));
      }

      jQuery(this).attr('value',valueCurrent);
        jQuery( "#cart_update" ).trigger( "click" );
  });


  jQuery('.input-number').on('input', function() {
    jQuery( "#cart_update" ).trigger( "click" );
  });

  jQuery('.trigger-btn').click(function(){
    jQuery( '.product_btn' ).trigger( "click" );
  });

// Welcome pop-up with cookie
  if ($ .cookie("popup_1_2") == null) {
    setTimeout(function(){
    jQuery('#welcome').foundation('open');
    }, 8000);
  $ .cookie("popup_1_2", "7");
   }
});


jQuery("li.trial button.btn-number").click(function(){
   jQuery("li.trial").find('.input-number').val('0');
   jQuery( "#cart_update" ).trigger( "click" );
 });


$(document).ready(function() {
  $('#play-video').on('click', function(ev) {
    this.style.display = 'none';
    thevid = document.getElementById('video');
    thevid.style.display = 'block';
    $("#video")[0].src += "?rel=0&controls=0&autoplay=1";
    ev.preventDefault();

  });

//   cart page dynamic date
  if($('.trial-pack-ship').length){
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var date = new Date();
    date.setDate(date.getDate() + 15);
    $('.ships-today.trial-pack-ship').html("First Restock " + monthNames[date.getMonth()] +" "+ date.getDate());
  }
});


// Review Page
var productID = jQuery('select#rc_duplicate_selector option').attr('value');
     jQuery.getJSON("/cart/update.js", function(cart) {
       var arrNames = [];
       Object.keys(cart.items).forEach(function(key) {
          var val = cart.items[key]["sku"];
          arrNames.push(val);
        });
         if(arrNames.includes('free-bar-trial')){
           jQuery('.try-mybtn').click(function(){
             jQuery(this).prepend('<i class="fa fa-spinner fa-spin"></i>&nbsp;');
             reChargeProcessCart();
           });
         } else {
           jQuery('.try-mybtn').click(function(e){
              e.preventDefault();
              jQuery(this).prepend('<i class="fa fa-spinner fa-spin"></i>&nbsp;');
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data : {
                   properties: {
                    shipping_interval_frequency: 30,
                    shipping_interval_unit_type: 'Days',
                    subscription_id: 221084,
                  },
                  quantity: 1,
                  id: productID
                },
                dataType: 'json',
                success: function(data) {
                  reChargeProcessCart();
                }
              });
          });
         }
    });


     jQuery.getJSON("/cart/update.js", function(cart) {
       var arrNames = [];
       Object.keys(cart.items).forEach(function(key) {
          var val = cart.items[key]["sku"];
          arrNames.push(val);
        });
         if(arrNames.includes('new-trial-flow')){
           jQuery('.reviewbtn').click(function(){
             jQuery(this).prepend('<i class="fa fa-spinner fa-spin"></i>&nbsp;');
             reChargeProcessCart();
           });
         } else {
           jQuery('.reviewbtn').click(function(e){
              e.preventDefault();
              jQuery(this).prepend('<i class="fa fa-spinner fa-spin"></i>&nbsp;');
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data : {
                   properties: {
                    shipping_interval_frequency: 30,
                    shipping_interval_unit_type: 'Days',
                    subscription_id: 230357,
                  },
                  quantity: 1,
                  id: productID
                },
                dataType: 'json',
                success: function(data) {
                  reChargeProcessCart();
                }
              });
          });
         }
    });

// Recharge checkout page redirection link
function reChargeProcessCart() {
    var customer_param = "";
    var myshopify_domain = "quantum-squares-dev.myshopify.com";
    var myshopify_domain_end = "";
        if (myshopify_domain.indexOf(':') > -1) {
            myshopify_domain = 'quantum-squares-dev';
            myshopify_domain_end = '.myshopify.com';
        }
    function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
    do {
        token=get_cookie('cart');
    }
    while(token == undefined);
    try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
    checkout_url= "https://checkout.quantumsquares.com/r/checkout?myshopify_domain="+myshopify_domain+myshopify_domain_end+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
    window.location = checkout_url;
    }

jQuery('li.Pack button.minus, li.review button.minus ').click(function(){
	localStorage.setItem('products', '');
    localStorage.setItem('Quantity', '');
});


$('.apply-new-btn a').click(function (){
    $('html, body').animate({
      scrollTop: $("#shopify-section-affiliate-let-do-it").offset().top - 100
    }, 1000)
  });
$('.affiliate-iron-hero-banner .iron-hero-btn .try_risk_btn').click(function (){
    $('html, body').animate({
      scrollTop: $("#shopify-section-affiliate-let-do-it").offset().top - 100
    }, 1000)
  });

$('.product-reveal-content [name="purchase_type"]').on('click', function (e) {
  if (e.target.value === 'onetime') {
    $('.home-product-reveal[aria-hidden="false"] .cancel-message').hide();
    $(e.target).parents('.form-workaround').first().data('purchaseType', 'single')
    console.log($(e.target).parents('.form-workaround').first().data('purchaseType'));
    console.log($(e.target).parents('.form-workaround').first());
  }
  if (e.target.value === 'autodeliver') {
    $('.home-product-reveal[aria-hidden="false"] .cancel-message').show();
      $(e.target).parents('.form-workaround').first().data('purchaseType', 'subscription')
      console.log($(e.target).parents('.form-workaround').first().data('purchaseType'));
      console.log($(e.target).parents('.form-workaround').first());
  }
})

$('.home-product-reveal').on('open.zf.reveal', function(){
  var $modal = $('#' + this.id)

  if ($modal.data('glitched') !== undefined) {
    return
  }
  $modal.data('glitched', true)
  $modal.find('.rc_price__autodeliver').first().click();

  $modal.find('.cancel-message').first().show()
})

$('.form-workaround').on('submit', function(e){
  var targetId = e.target.dataset.productid;
  var type = $('form[data-productid="' + targetId + '"]').data('purchaseType')
  console.log(type);
  console.log($('#form-' + targetId));
  if (type == 'single') {

  } else {
    e.preventDefault();
    $('#subs-form-' + targetId).submit();
  }
})

window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
      check = true;
    }
  )(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
$(document).ready(function() {
  window.mobileCheck = function () {
    let check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
        check = true;
      }
    )(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };
  if (window.mobileCheck()) {
    $('#mobile-hero-video')[0].play();
  }
});

// $(document).ready(function() {
//   $('#newsletter-form').on('submit', function (e){
//     e.preventDefault();
//     _learnq.push([
//       'identify', {
//         '$email' : $('#newsletter-email').val();
//       }
//     ])
//   })
// });

$('#offCanvas').on('opened.zf.offcanvas', function(){
  $('#header-hamburger').addClass('is-active');
})
$('#offCanvas').on('closed.zf.offcanvas', function(){
  $('#header-hamburger').removeClass('is-active');
})

$(document).ready(function() {
  $('#offCanvas').removeClass('hidden-on-load');

  // Ripple Effect
  let surface, ripple;
  const initRipple = function() {
    surface = document.getElementsByClassName('ud-ripple-surface');
    // surface = document.querySelectorAll('.ud-ripple-surface:not(.ud-ripple-init)');
    // surface = document.querySelectorAll('.ud-ripple-surface');

    Array.prototype.forEach.call(surface, function(b) {
      var circle = document.createElement('span');

      b.addEventListener('click', createRipple);
      b.appendChild(circle);
      circle.classList.add('ud-ripple');
      b.classList.add('ud-ripple-init');
    });
  };
  setTimeout(initRipple);

  const createRipple = function(e) {
    ripple = this;
    circle = this.querySelector('.ud-ripple');
    // circle = document.createElement('span');

    var rect = ripple.getBoundingClientRect(),
        d = Math.max(ripple.clientWidth, ripple.clientHeight);

    ripple.style.overflow = 'hidden';
    // ripple.appendChild(circle);

    circle.style.width = circle.style.height = d + 'px';
    circle.style.left = e.clientX - rect.left - d/2 + 'px';
    circle.style.top = e.clientY - rect.top - d/2 + 'px';
    // circle.classList.add('ud-ripple');
    ripple.classList.add('ud-ripple--active');

    // $.throttle(250, destroyRipple);
    setTimeout(destroyRipple, 400);
  };

  const destroyRipple = function() {
    ripple.style.overflow = 'visible';
    ripple.classList.remove('ud-ripple--active');
    // ripple.removeChild(circle);
  };
})
